import { ReactNode } from "react";
import { IconButton, SxProps, Theme } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@/components/app/DeleteIcon";
import Flex from "@/components/Flex";

export interface EntryCardProps {
  children: ReactNode;
  onRemove?: () => void;
  removeLabel?: string;
  onEdit?: () => void;
  editLabel?: string;
  sx?: SxProps<Theme>;
}

const EntryCard = ({
  children,
  onRemove,
  removeLabel,
  onEdit,
  editLabel,
  sx,
}: EntryCardProps) => (
  <Flex
    gap={1}
    alignItems="flex-start"
    sx={[
      { border: "1px solid #E0E0E0", borderRadius: 1, p: 1.5 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <Flex flex={1} minWidth={0} flexDirection="column" gap={1.5}>
      {children}
    </Flex>
    {onEdit && (
      <IconButton aria-label={editLabel} onClick={onEdit}>
        <EditOutlinedIcon fontSize="small" color="primary" />
      </IconButton>
    )}
    {onRemove && <DeleteIcon aria-label={removeLabel} onClick={onRemove} />}
  </Flex>
);

export default EntryCard;
